/**
 * Universal PDP - Flavor Selector
 * Handles flavor selection for FloFit protein products
 * Only loads on FloFit product pages
 */

(function() {
  'use strict';

  // Check if flavor selector exists on page
  const flavorSelector = document.querySelector('.flavor-selector');
  if (!flavorSelector) {
    return; // Exit if no flavor selector found
  }

  // Get all flavor option buttons
  const flavorButtons = document.querySelectorAll('[data-flavor-action="select"]');
  const selectedFlavorDisplay = document.getElementById('selectedFlavor');

  // Initialize: Get first flavor from the first button
  const firstButton = flavorButtons[0];
  let currentFlavor = firstButton ? firstButton.getAttribute('data-flavor') : 'Double Chocolate';
  
  /**
   * Update the selected flavor display
   * @param {string} flavorName - Name of the selected flavor
   */
  function updateSelectedFlavor(flavorName) {
    if (selectedFlavorDisplay) {
      selectedFlavorDisplay.textContent = flavorName;
    }
    currentFlavor = flavorName;
  }

  /**
   * Update quantity selector images based on selected flavor
   * @param {HTMLElement} flavorButton - The flavor button with image data
   */
  function updateQuantityImages(flavorButton) {
    if (!flavorButton) {
      console.warn('⚠️ updateQuantityImages called with null/undefined button');
      return;
    }
    
    // Get the flavor-specific images from data attributes
    const image1 = flavorButton.getAttribute('data-flavor-image-1');
    const image3 = flavorButton.getAttribute('data-flavor-image-3');
    const image6 = flavorButton.getAttribute('data-flavor-image-6');
    const flavorName = flavorButton.getAttribute('data-flavor');
    
    console.log('🖼️ Updating quantity images for flavor:', flavorName);
    console.log('   Image URLs:', { '1': image1, '3': image3, '6': image6 });
    
    // Find all quantity selector buttons
    const quantityOptions = document.querySelectorAll('.pdp-details__selection-option[data-quantity]');
    console.log('   Found', quantityOptions.length, 'quantity options to update');
    
    quantityOptions.forEach(option => {
      const quantity = option.getAttribute('data-quantity');
      const imgElement = option.querySelector('.pdp-details__selection-image');
      
      if (!imgElement) {
        console.warn('   ⚠️ No image element found for quantity:', quantity);
        return;
      }
      
      let newImageUrl = null;
      
      // Match quantity to the appropriate flavor image
      if (quantity === '1' && image1) {
        newImageUrl = image1;
      } else if (quantity === '3' && image3) {
        newImageUrl = image3;
      } else if (quantity === '6' && image6) {
        newImageUrl = image6;
      }
      
      // Update the image if we have a URL (check for valid URL, not just truthy)
      if (newImageUrl && newImageUrl !== 'null' && newImageUrl.trim() !== '') {
        let normalizedUrl = newImageUrl.trim();
        if (normalizedUrl.startsWith('//')) {
          normalizedUrl = `${window.location.protocol}${normalizedUrl}`;
        }
        
        console.log('   ✅ Updating quantity', quantity, 'image');
        console.log('      Old:', imgElement.src);
        console.log('      New:', normalizedUrl);
        
        imgElement.src = normalizedUrl;
        
        // Also update srcset if present (for responsive images)
        if (imgElement.hasAttribute('srcset')) {
          imgElement.srcset = normalizedUrl;
        }
        
        // Remove data-src to prevent lazy loading from reverting
        if (imgElement.hasAttribute('data-src')) {
          imgElement.removeAttribute('data-src');
        }
      } else {
        console.warn('   ⚠️ No valid image URL for quantity', quantity, '- got:', newImageUrl);
      }
    });
    
    console.log('✅ Quantity image update complete for:', flavorName);
  }

  /**
   * Handle flavor selection
   * @param {HTMLElement} clickedButton - The button that was clicked
   */
  function selectFlavor(clickedButton) {
    const flavorName = clickedButton.getAttribute('data-flavor');
    
    if (!flavorName) {
      console.warn('No flavor name found on button');
      return;
    }

    console.log('selectFlavor called with:', flavorName);

    // Remove active class from all buttons
    flavorButtons.forEach(button => {
      button.classList.remove('flavor-selector__option--active');
    });

    // Add active class to clicked button
    clickedButton.classList.add('flavor-selector__option--active');

    // Update the selected flavor display and internal state
    updateSelectedFlavor(flavorName);

    // Update quantity selector images to match this flavor
    updateQuantityImages(clickedButton);

    // Trigger custom event for other scripts (like pricing) to listen to
    document.dispatchEvent(new CustomEvent('flavorChanged', {
      detail: { flavor: flavorName }
    }));

    // Store selection in sessionStorage for persistence
    try {
      sessionStorage.setItem('selectedFlavor', flavorName);
      console.log('Saved to sessionStorage:', flavorName);
    } catch (e) {
      console.warn('Could not save flavor selection to sessionStorage:', e);
    }

    // Track flavor selection for analytics
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        'event': 'flavor_selected',
        'flavor_name': flavorName
      });
    }
    
    console.log('✓ Flavor successfully selected:', flavorName, 'Current flavor is now:', currentFlavor);
  }

  // Add click event listeners to all flavor buttons
  flavorButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log('Button clicked:', this.getAttribute('data-flavor'));
      selectFlavor(this);
    }, true); // Use capture phase
  });

  // Initialize with first flavor (update currentFlavor properly)
  if (firstButton) {
    currentFlavor = firstButton.getAttribute('data-flavor');
  }

  // Prefer flavor from URL variant so shared links open with correct selection (e.g. Vanilla 1 month)
  let restored = false;
  if (window.getVariantIdFromUrl && window.getVariantInfoFromVariantId) {
    const urlVariantId = window.getVariantIdFromUrl();
    if (urlVariantId) {
      const urlVariantInfo = window.getVariantInfoFromVariantId(urlVariantId);
      if (urlVariantInfo && urlVariantInfo.flavor) {
        const flavorLower = String(urlVariantInfo.flavor).toLowerCase();
        flavorButtons.forEach(button => {
          const btnFlavor = button.getAttribute('data-flavor');
          if (btnFlavor && (btnFlavor === urlVariantInfo.flavor || btnFlavor.toLowerCase() === flavorLower)) {
            selectFlavor(button);
            restored = true;
          }
        });
        if (!restored && flavorLower) {
          flavorButtons.forEach(button => {
            const btnFlavor = (button.getAttribute('data-flavor') || '').toLowerCase();
            if (btnFlavor && btnFlavor.indexOf(flavorLower) !== -1 || flavorLower.indexOf(btnFlavor) !== -1) {
              selectFlavor(button);
              restored = true;
            }
          });
        }
      }
    }
  }

  // Restore previously selected flavor from sessionStorage (if URL did not set it)
  if (!restored) {
    try {
      const savedFlavor = sessionStorage.getItem('selectedFlavor');
      if (savedFlavor) {
        flavorButtons.forEach(button => {
          if (button.getAttribute('data-flavor') === savedFlavor) {
            selectFlavor(button);
            restored = true;
          }
        });
      }
    } catch (e) {
      console.warn('Could not restore flavor selection from sessionStorage:', e);
    }
  }

  // If no saved flavor was restored, ensure first button is active
  if (!restored && firstButton) {
    firstButton.classList.add('flavor-selector__option--active');
    if (selectedFlavorDisplay) {
      selectedFlavorDisplay.textContent = currentFlavor;
    }
    // Initialize quantity images with first flavor - use timeout to ensure DOM is ready
    setTimeout(() => {
      console.log('🔄 Initializing quantity images for first flavor:', currentFlavor);
      updateQuantityImages(firstButton);
    }, 100);
  }

  // Also force update on window load as fallback
  window.addEventListener('load', function() {
    const activeFlavorButton = document.querySelector('.flavor-selector__option--active');
    if (activeFlavorButton) {
      console.log('🔄 Window loaded - updating images for active flavor');
      updateQuantityImages(activeFlavorButton);
    }
  });

  // Expose current flavor selection to other scripts if needed
  window.getSelectedFlavor = function() {
    return currentFlavor;
  };

  console.log('Flavor selector initialized. Current flavor:', currentFlavor);

})();

